module.exports = __webpack_public_path__ + "img/logo.bc9e11db.png";